import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import cx from 'classnames'
import { Card } from 'components/Card'
import { Icon } from 'components/Icon'
import { Text } from 'components/Text'
import { WidgetGroup } from './components/WidgetGroup'
import { Flex } from 'components/Flex'
import { useProjectContext } from 'context/project-context'
import styles from './Widgets.module.scss'

type WidgetsProps = {
  double: boolean
}

export const Widgets: FC<WidgetsProps> = ({ double }) => {
  const { t } = useTranslation()
  const [{ activeLayers }] = useProjectContext()

  const classes = cx({
    [styles.widgets]: true,
    [styles.double]: double,
    [styles.empty]: activeLayers.length === 0,
  })

  return (
    <div className={classes}>
      {activeLayers.length === 0 ? (
        <Card className={styles.placeholder}>
          <Flex justify="center" align="center" direction="vertical" gap="md">
            <Icon name="stack-line" className={styles.placeholderIcon} />
            <Text align="center" weight="strong">
              {t('widgets.no_layer_selected')}
            </Text>
          </Flex>
        </Card>
      ) : (
        activeLayers.map((layerId) => <WidgetGroup key={`widgets-${layerId}`} layerId={layerId} />)
      )}
    </div>
  )
}

Widgets.displayName = 'Widgets'
